// // import React from "react";
// // import { FaCheckCircle } from "react-icons/fa";
// // import { Link } from "react-router-dom";

// // const PaymentSuccess = () => {
// //   return (
// //     <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 px-4">
// //       <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center animate-fade-in">
// //         {/* Icon */}
// //         <div className="flex justify-center mb-4">
// //           <FaCheckCircle className="text-green-500 md:text-7xl text-5xl" />
// //         </div>

// //         {/* Title & Message */}
// //         <h2 className="text-2xl font-bold text-gray-800">Payment Successful</h2>
// //         <p className="text-gray-600 mt-2">
// //           Thank you for your payment. Your order is being processed.
// //         </p>

// //         <hr className="my-6 border-gray-300" />

// //         {/* Payment Details */}
// //         <div className="text-left text-sm text-gray-700 space-y-2">
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Amount Paid:</span>
// //             <span className="font-semibold text-black">Rs 99.99</span>
// //           </div>
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Payment Method:</span>
// //             <span className="text-black">Visa ending in 1234</span>
// //           </div>
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Date & Time:</span>
// //             <span className="text-black">April 18, 2024 at 3:45 PM</span>
// //           </div>
// //         </div>

// //         {/* Button */}
// //         <div className="mt-6">
// //           <Link to="/">
// //             <button
// //               className="bg-gray-900 text-white px-5 py-2 rounded-md hover:bg-gray-800 transition"
// //               onClick={() => (window.location.href = "/")} // Change URL if needed
// //             >
// //               Go to Home
// //             </button>
// //           </Link>
// //         </div>
// //       </div>

// //       {/* Animation */}
// //       <style>
// //         {`
// //           @keyframes fade-in {
// //             0% { opacity: 0; transform: scale(0.95); }
// //             100% { opacity: 1; transform: scale(1); }
// //           }
// //           .animate-fade-in {
// //             animation: fade-in 0.3s ease-out;
// //           }
// //         `}
// //       </style>
// //     </div>
// //   );
// // };

// // export default PaymentSuccess;

// import React, { useEffect, useState } from "react";
// import { useSearchParams, Link } from "react-router-dom";
// import BASE_URL from "../../config/config";

// const PaymentSuccess = () => {
//   const [q] = useSearchParams();
//   const txnId = q.get("txnid");
//   const [txn, setTxn] = useState(null);

//   useEffect(() => {
//     if (txnId) {
//       fetch(`${BASE_URL}/payments/txns/${txnId}`)
//         .then((r) => (r.ok ? r.json() : null))
//         .then(setTxn)
//         .catch(console.error);
//     }
//   }, [txnId]);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-green-50 p-6">
//       <div className="bg-white shadow rounded-xl p-8 max-w-lg w-full text-center">
//         <h1 className="text-3xl font-bold text-green-600">
//           Payment Successful ✅
//         </h1>
//         <p className="mt-2 text-gray-600">
//           Thank you! Your payment was received.
//         </p>
//         {txn && (
//           <div className="mt-6 text-left bg-gray-50 p-4 rounded">
//             <p>
//               <b>Txn ID:</b> {txn.txnId}
//             </p>
//             <p>
//               <b>Name:</b> {txn.firstName} {txn.lastName}
//             </p>
//             <p>
//               <b>Email:</b> {txn.email}
//             </p>
//             <p>
//               <b>Phone:</b> {txn.phone}
//             </p>
//             <p>
//               <b>Amount:</b> ₹{txn.amount}
//             </p>
//             <p>
//               <b>Status:</b> {txn.status}
//             </p>
//             <p>
//               <b>Product:</b> {txn.productInfo}
//             </p>
//             <p>
//               <b>Company:</b> {txn.companyName}
//             </p>
//           </div>
//         )}
//         <Link
//           to="/pay"
//           className="inline-block mt-6 px-4 py-2 bg-sky-600 text-white rounded"
//         >
//           Make another payment
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default PaymentSuccess;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";

// const PaymentSuccess = () => {
//   const [paymentData, setPaymentData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const processPayment = async () => {
//       try {
//         // Extract parameters from URL
//         const params = new URLSearchParams(location.search);
//         const txnId = params.get("txnid");

//         if (!txnId) {
//           setError("Transaction ID not found");
//           setLoading(false);
//           return;
//         }

//         // Verify payment with backend
//         const response = await axios.get(
//           `${BASE_URL}/payment/verify/${txnId}`
//         );
//         setPaymentData(response.data);
//       } catch (err) {
//         console.error("Payment verification error:", err);
//         setError(err.response?.data?.error || "Failed to verify payment");
//       } finally {
//         setLoading(false);
//       }
//     };

//     processPayment();
//   }, [location]);

//   const downloadReceipt = () => {
//     if (!paymentData) return;

//     // Create a printable receipt
//     const receiptContent = `
//             <html>
//                 <head>
//                     <title>Payment Receipt - ${paymentData.txnId}</title>
//                     <style>
//                         body { font-family: Arial, sans-serif; margin: 40px; }
//                         .header { text-align: center; margin-bottom: 30px; }
//                         .details { margin-bottom: 20px; }
//                         .detail-row { display: flex; margin-bottom: 8px; }
//                         .detail-label { font-weight: bold; width: 180px; }
//                         .footer { margin-top: 40px; font-size: 12px; text-align: center; }
//                         @media print {
//                             body { margin: 0; }
//                             .no-print { display: none; }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <div class="header">
//                         <h1>Payment Receipt</h1>
//                         <p>DeetyaSoft Solutions</p>
//                     </div>
//                     <div class="details">
//                         <div class="detail-row">
//                             <span class="detail-label">Transaction ID:</span>
//                             <span>${paymentData.txnId}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Date:</span>
//                             <span>${new Date(
//                               paymentData.createdAt
//                             ).toLocaleString()}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Amount:</span>
//                             <span>₹${paymentData.amount}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Product:</span>
//                             <span>${paymentData.productInfo}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Status:</span>
//                             <span style="color: green; font-weight: bold;">Success</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Payment ID:</span>
//                             <span>${paymentData.payuPaymentId || "N/A"}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Bank Reference:</span>
//                             <span>${paymentData.bankRefNum || "N/A"}</span>
//                         </div>
//                         <div class="detail-row">
//                             <span class="detail-label">Payment Mode:</span>
//                             <span>${paymentData.mode || "N/A"}</span>
//                         </div>
//                     </div>
//                     <div class="footer">
//                         <p>Thank you for your payment!</p>
//                         <p>DeetyaSoft Solutions - https://deetyasoft.com</p>
//                     </div>
//                 </body>
//             </html>
//         `;

//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(receiptContent);
//     printWindow.document.close();
//     printWindow.focus();
//     printWindow.print();
//   };

//   const downloadAsPDF = async () => {
//     // This would typically call a backend service to generate a PDF
//     console.log("Downloading PDF receipt for:", paymentData.txnId);
//     // In a real implementation, you would likely:
//     // 1. Call a backend API to generate PDF
//     // 2. Receive a URL to download
//     alert("PDF download functionality would be implemented here");
//   };

//   if (loading) {
//     return (
//       <div className="payment-status-container">
//         <div className="loading-spinner"></div>
//         <p>Verifying your payment...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="payment-status-container error">
//         <h2>Verification Error</h2>
//         <p>{error}</p>
//         <button onClick={() => navigate("/")}>Return to Home</button>
//       </div>
//     );
//   }

//   return (
//     <div className="payment-status-container success">
//       <div className="status-header">
//         <div className="success-icon">✓</div>
//         <h1>Payment Successful</h1>
//         <p>
//           Thank you for your payment. Your transaction has been completed
//           successfully.
//         </p>
//       </div>

//       <div className="payment-details">
//         <h2>Transaction Details</h2>
//         <div className="details-grid">
//           <div className="detail-item">
//             <span className="detail-label">Transaction ID:</span>
//             <span className="detail-value">{paymentData.txnId}</span>
//           </div>
//           <div className="detail-item">
//             <span className="detail-label">Amount:</span>
//             <span className="detail-value">₹{paymentData.amount}</span>
//           </div>
//           <div className="detail-item">
//             <span className="detail-label">Date:</span>
//             <span className="detail-value">
//               {new Date(paymentData.createdAt).toLocaleString()}
//             </span>
//           </div>
//           <div className="detail-item">
//             <span className="detail-label">Product:</span>
//             <span className="detail-value">{paymentData.productInfo}</span>
//           </div>
//           {paymentData.payuPaymentId && (
//             <div className="detail-item">
//               <span className="detail-label">Payment ID:</span>
//               <span className="detail-value">{paymentData.payuPaymentId}</span>
//             </div>
//           )}
//           {paymentData.bankRefNum && (
//             <div className="detail-item">
//               <span className="detail-label">Bank Reference:</span>
//               <span className="detail-value">{paymentData.bankRefNum}</span>
//             </div>
//           )}
//           {paymentData.mode && (
//             <div className="detail-item">
//               <span className="detail-label">Payment Mode:</span>
//               <span className="detail-value">{paymentData.mode}</span>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="action-buttons">
//         <button onClick={downloadReceipt} className="btn-primary">
//           Print Receipt
//         </button>
//         <button onClick={downloadAsPDF} className="btn-secondary">
//           Download as PDF
//         </button>
//         <button onClick={() => navigate("/")} className="btn-outline">
//           Return to Home
//         </button>
//       </div>

//       <div className="support-info">
//         <p>
//           If you have any questions about your payment, please contact our
//           support team.
//         </p>
//         <p>Email: support@deetyasoft.com | Phone: +91-XXXXX-XXXXX</p>
//       </div>
//     </div>
//   );
// };

// export default PaymentSuccess;

// SuccessPage.jsx;
// import { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import BASE_URL from "../../config/config";
// export default function SuccessPage() {
//   const [params] = useSearchParams();
//   const [tx, setTx] = useState(null);
//   const txnid = params.get("txnid");

//   useEffect(() => {
//     fetch(`${BASE_URL}/payments/txns/${txnid}`)
//       .then((res) => res.json())
//       .then(setTx);
//   }, [txnid]);

//   if (!tx) return <p>Loading...</p>;

//   return (
//     <div className="p-6">
//       <h1 className="text-green-600 text-2xl font-bold">
//         Payment Successful 🎉
//       </h1>
//       <p>Transaction ID: {tx.txnid}</p>
//       <p>Amount: ₹{tx.amount}</p>
//       <p>Product: {tx.productinfo}</p>
//       <p>Status: {tx.status}</p>
//       <p>Payment Mode: {tx.mode}</p>
//       <p>Date : {tx.createdAt}</p>
//       <p>Ref No : {tx.upi_ref_no}</p>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import BASE_URL from "../../config/config";
import { FaCheckCircle, FaDownload, FaHome } from "react-icons/fa";

export default function SuccessPage() {
  const [params] = useSearchParams();
  const [tx, setTx] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const txnid = params.get("txnid");
  const navigate = useNavigate();

  useEffect(() => {
    if (txnid) {
      fetch(`${BASE_URL}/payments/txns/${txnid}`)
        .then((res) => res.json())
        .then(setTx)
        .catch((err) => console.error("Error fetching transaction:", err));
    }
  }, [txnid]);

  const handleDownload = async () => {
    if (!txnid) return;
    setDownloading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/payments/download-receipt/${txnid}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/pdf" },
        }
      );
      if (!response.ok) throw new Error("Failed to download receipt");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Receipt_${txnid}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download receipt. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  if (!tx)
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="animate-pulse text-gray-500 text-lg">
          Loading payment details...
        </div>
      </div>
    );

  return (
    <div className="min-h-[80vh] py-4 flex items-center justify-center bg-gradient-to-br from-emerald-50 via-white to-emerald-100 px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl border border-emerald-200 p-8 text-center relative overflow-hidden transition-all duration-200 hover:shadow-green-200">
        {/* Success Icon */}
        <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-r from-green-400 via-emerald-500 to-green-600"></div>
        <div className="flex flex-col items-center mb-4">
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg mb-2 ">
            <FaCheckCircle className="text-3xl" />
          </div>
          <h1 className="text-[25px] font-extrabold text-emerald-600">
            Payment Successful!
          </h1>
          <p className="text-gray-600 mt-1">
            Thank you for your payment — your transaction was completed
            successfully.
          </p>
        </div>

        {/* Transaction Details */}
        <div className="text-left text-gray-700 border-t pt-4 space-y-2">
          <div className="flex justify-between">
            <span className="font-semibold">Transaction ID:</span>
            <span>{tx.upiRefNo}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Amount:</span>
            <span className="text-green-600 font-bold">₹{tx.amount}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Product:</span>
            <span>{tx.product}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Status:</span>
            <span
              className={`${
                tx.status === "success" ? "text-green-600" : "text-red-600"
              } font-semibold`}
            >
              {tx.status?.toUpperCase()}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Payment Mode:</span>
            <span>{tx.paymentMode}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Date:</span>
            <span>{new Date(tx.date).toLocaleString()}</span>
          </div>
          {/* <div className="flex justify-between">
            <span className="font-semibold">Ref No:</span>
            <span>{tx.upiRefNo || "N/A"}</span>
          </div> */}
        </div>

        {/* Buttons */}
        <div className="mt-8 flex flex-col gap-3">
          <button
            onClick={handleDownload}
            disabled={downloading}
            className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-emerald-600 to-green-700 text-white py-3 rounded-full font-semibold text-lg shadow-md hover:shadow-lg transition-all duration-300 disabled:opacity-50"
          >
            <FaDownload />
            {downloading ? "Downloading..." : "Download Receipt"}
          </button>

          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 w-full bg-white border-2 border-emerald-500 text-emerald-700 py-3 rounded-full font-semibold hover:bg-emerald-50 transition-all duration-300"
          >
            <FaHome />
            Back to Home
          </button>
        </div>

        {/* Footer Line */}

        <p className="text-xs text-gray-400 mt-4">
          Need help?{" "}
          <a
            href="mailto:support@ivrguru.com"
            className="text-blue-500 hover:underline"
          >
            Contact: support@ivrguru.com
          </a>
        </p>
      </div>
    </div>
  );
}
